import { breakpoints, matchBreakpoint } from "../common/utils";
($ => {
  const cat = $(".filter-ajax .js-filter-link");
  const selectedFiltersList = $(".selected-filters__list");
  const selectedF = $(".selected-filters__list__item");
  const spinner = $("#loader");
  const container = $(".o-product-loop-container");
  let apps = $(".application-filter .application-filter__list-label");
  const selectedFiltersArr = [];
  let dataCategory;
  let category;
  let aplica = [];
  let data = {
    action: "filter",
    categorySlug: category,
    aplica: aplica
  };
  const closeFiltersNav = event => {
    if ($(".c-aside-sidebar-nav").hasClass("show-filters")) {
      $(".c-aside-sidebar-nav").trigger("click");
    }
  };

  const updateNumberPosts = event => {
    $(".posts-counter-js").each(function() {
      let self = $(this);

      self.text($(".o-product-loop").data("count-posts"));
    });
  };

  const removeSingleFilter = el => {
    let li = $("[data-application-name='" + el.data("single-filter") + "']");
    let allClearBtn = $(
      "[data-single-filter='" + el.data("single-filter") + "']"
    );
    let selectedLi = $(".application-filter__list").find(li);

    if (el.data("single-filter") == selectedFiltersList.data("clear-all")) {
      $(".application-filter__list-label.selected").each(function() {
        let self = $(this);

        self.trigger("click");
      });
      allClearBtn.each(function() {
        let self = $(this);

        self.remove();
      });
    } else {
      selectedLi.trigger("click");
    }

    self.off("click");
  };

  const updateAppsMenu = el => {
    el.find("[data-application-name]").each(function() {
      const name = $(this).data("application-name");
      const updatedName = el.find(
        "[data-upadte-application-name='" + name + "']"
      );
      let updatedVal = updatedName.siblings(".input-checkbox-num").text();

      if (updatedVal == "") {
        updatedVal = 0;
      }

      $(this)
        .siblings(".input-checkbox-num")
        .text(updatedVal);
    });
  };

  const initAjax = () => {
    $.ajax({
      url: myajax.ajaxurl,
      data: {
        action: "filter",
        category: dataCategory,
        aplica: aplica
      },
      type: "POST",
      beforeSend: function() {
        spinner.addClass("loading");
        container.addClass("opacity");
      },
      success: function(data) {
        $(".js-filter").html(data);
        // Add to comparision
        if (
          $("#products-comparision-products > .products-comparision__product")
            .length
        ) {
          let elAjax = $(".c-product-similar-in-category__item");
          let elCompare = $(
            "#products-comparision-products > .products-comparision__product"
          );
          let arrCompareCategory = [];
          let arrCompare = [];

          elCompare.each(function() {
            let elCompareID = $(this).data("id");
            let elCompareCategory = $(this).data("category");

            arrCompare.push(elCompareID);
            arrCompareCategory.push(elCompareCategory);
          });
          elAjax.each(function() {
            let elAjaxID = $(this)
              .find(".products-comparision-add-button")
              .data("id");
            let elAjaxCategory = $(this)
              .find(".products-comparision-add-button")
              .data("category");

            if (jQuery.inArray(elAjaxID, arrCompare) !== -1) {
              let button = $(this).find(".products-comparision-add-button");

              button.children().removeClass("active");
              button
                .children(".products-comparison-label--remove")
                .addClass("active");
              button.attr("data-on-list", true);
            }

            if (jQuery.inArray(elAjaxCategory, arrCompareCategory) === -1) {
              let button = $(this).find(".products-comparision-add-button");

              button.children().removeClass("active");
              button
                .children(".products-comparison-label--different")
                .addClass("active");
              button.attr("data-on-list", false);
            }
          });
        }
      },
      complete: function() {
        $("#main-posts-counter").remove();
        $("#loadMore").remove();
        updateNumberPosts();
        spinner.removeClass("loading");
        container.removeClass("opacity");
        $(".selected-filters__list__item").each(function() {
          let self = $(this);

          self.on("click", e => removeSingleFilter(self));
        });
      },
      error: function(data) {
        console.warn(data);
      }
    });
  };

  const initAjaxLoadMore = page => {
    let loadMoreParams = {
      action: "loadmore",
      page: page
    };

    if (productsCategorySlug) loadMoreParams.category = productsCategorySlug;
    $.ajax({
      url: myajax.ajaxurl,
      data: loadMoreParams,
      type: "POST",
      beforeSend: function() {
        spinner.addClass("loading");
        container.addClass("opacity");
      },
      success: function(data) {
        if (data.trim().length) {
          $(data).appendTo(".o-product-loop");
          $("#loadMore").data("page", page + 1);
          if (page * productsPerPage >= productsCounter) {
            $("#loadMore").remove();
          }
        } else {
          $("#loadMore").remove();
        }
      },
      complete: function() {
        spinner.removeClass("loading");
        container.removeClass("opacity");
      },
      error: function(data) {
        console.warn(data);
      }
    });
  };

  const initAjaxMenu = () => {
    $.ajax({
      url: myajax.ajaxurl,
      data: {
        action: "applications",
        category: dataCategory
      },
      type: "POST",

      success: function(data) {
        console.log("success");
        $(".update-js").html(data);
      },
      complete: function() {
        $("#loadMore").remove();
        $("#main-posts-counter").remove();
        updateAppsMenu($(".c-aside-sidebar"));
        updateNumberPosts();
      },
      error: function(data) {
        console.warn(data);
      }
    });
  };

  const removeSelectedFilters = value => {
    let li = $("[data-single-filter='" + value + "']");
    let selectedLi = selectedFiltersList.find(li);

    selectedLi.remove();
  };

  const updateFiltersInSidebar = () => {
    let third = $(".selected-filters__list.in-sidebar").children(
      ":nth-child(2)"
    );

    $(".filters-counter-js").text(
      $(".application-filter__list-label.selected").length
    );
    $(".filters-counter-js").addClass("not-empty");
    if ($(".selected-filters__list.in-sidebar").children().length > 3) {
      let countFilters =
        $(".selected-filters__list.in-sidebar").children().length - 3;

      if (third.children().length > 0) {
        third.children("span").text(countFilters);
      } else {
        $(".selected-filters__list.in-sidebar")
          .children(":nth-child(2)")
          .append("<span> +" + countFilters + " </span>");
      }
    } else if (third.children().length > 0) {
      third.children("span").remove();
    }
  };

  const addClearLink = value => {
    let li =
      '<li class="selected-filters__list__item" data-single-filter="' +
      value +
      '">' +
      value +
      "</li>";

    selectedFiltersList.prepend(li);
  };

  const addSelectedFilters = value => {
    let li =
      '<li class="selected-filters__list__item" data-single-filter="' +
      value +
      '">' +
      value +
      "</li>";

    selectedFiltersList.prepend(li);
  };

  const filterByCat = (event, self) => {
    if (event.target.nodeName == "SPAN") {
      return;
    } else {
      apps = $(".application-filter .application-filter__list-label");
      event.preventDefault();

      if (self.parent().siblings(".c-aside-navigation__item")) {
        self
          .closest(".c-aside-navigation__parent")
          .find(".selected")
          .removeClass("selected");
      }

      dataCategory = self.data("category");
      self.addClass("selected");
      category = dataCategory;
      initAjax();
      initAjaxMenu();
    }
  };

  const filterByApps = (event, self) => {
    event.preventDefault();

    const dataApp = self.find("input").data("application-val");
    const dataAppName = self.find("input").data("application-name");

    if (selectedFiltersArr.includes(dataAppName)) {
      let selectedFilterIndex = selectedFiltersArr.indexOf(dataAppName);

      selectedFiltersArr.splice(selectedFilterIndex, 1);
      removeSelectedFilters(dataAppName);
    } else {
      selectedFiltersArr.unshift(dataAppName);
      addSelectedFilters(dataAppName);
    }

    if (
      selectedFiltersArr.length > 0 &&
      selectedFiltersList.find(".selected-filters__list__item--clear").length ==
        0
    ) {
      let clearAll =
        '<li class="selected-filters__list__item selected-filters__list__item--clear" data-single-filter="' +
        selectedFiltersList.data("clear-all") +
        '">' +
        selectedFiltersList.data("clear-all") +
        "</li>";

      selectedFiltersList.append(clearAll);
    }

    cat.each(function() {
      if ($(this).hasClass("selected")) {
        dataCategory = $(this).data("category");
      }
    });
    self.toggleClass("selected");
    if (self.hasClass("selected")) {
      aplica.unshift(dataApp);
    } else {
      let index = aplica.indexOf(dataApp);

      aplica.splice(index, 1);
    }

    initAjax();
    updateFiltersInSidebar();
  };

  const addFiltersOnStart = () => {
    $(".application-filter__list-item.selected").length > 0 &&
      $(".application-filter__list-item.selected").each(function() {
        let self = $(this);
        let currentFilter = self.find("input").data("application-name");

        addSelectedFilters(currentFilter);
        selectedFiltersArr.push(currentFilter);
        $(".selected-filters__list__item").on("click", e =>
          removeSingleFilter($(".selected-filters__list__item"))
        );
      });
  };

  $(document).ready(() => {
    updateNumberPosts();
    apps.each(function() {
      let self = $(this);

      self.on("click", e => filterByApps(e, self));
    });

    $("body").on("click", "#loadMore", function(e) {
      e.preventDefault();
      let page = parseInt($(this).data("page"));

      initAjaxLoadMore(page);
    });

    $("body").on("click", function(event) {
      if (event.target.nodeName === "BODY") {
        closeFiltersNav();
      }
    });
    $(".trigger-ajax").on("click", function() {
      closeFiltersNav();
    });
    addFiltersOnStart();
  });
})(jQuery);
